module.exports = __webpack_public_path__ + "img/discourse.469ca268.svg";